import { Box, Divider, IconButton, Stack, Typography, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { Instagram as InstagramIcon } from "@mui/icons-material";
import { ADDRESS, EMAIL, PHONE, SCHEDULE, homaLogo } from "./data";

export function Footer() {
  const theme = useTheme();
  const contrastColor = theme.palette.primary.contrastText;
  const dividerColor = alpha(contrastColor, 0.3);

  return (
    <Box sx={{ display: { xs: "none", md: "block" } }}>
      <Stack
        direction="row"
        flexWrap="wrap"
        alignItems="center"
        justifyContent="center"
        divider={<Divider orientation="vertical" flexItem sx={{ borderColor: dividerColor }} />}
        spacing={3}
        sx={{ backgroundColor: "primary.main", color: contrastColor, px: 4, py: 2 }}
      >
        <Typography sx={{ fontWeight: 700 }}>VOLT BJJ</Typography>
        <Typography variant="body2">{ADDRESS}</Typography>
        <Typography
          variant="body2"
          onClick={() => window.open(`tel:${PHONE.replace(/-/g, "")}`)}
          sx={{ cursor: "pointer", "&:hover": { color: alpha(contrastColor, 0.6) } }}
        >
          {PHONE}
        </Typography>
        <Typography
          variant="body2"
          onClick={() => {
            window.location.href = `mailto:${EMAIL}`;
          }}
          sx={{ cursor: "pointer", "&:hover": { color: alpha(contrastColor, 0.6) } }}
        >
          {EMAIL}
        </Typography>
        <Typography variant="body2">
          {SCHEDULE.map((s) => `${s.day.slice(0, 3)} ${s.hours}`).join(" · ")}
        </Typography>
        <IconButton
          size="small"
          sx={{ color: "inherit", "&:hover": { color: alpha(contrastColor, 0.6) } }}
          onClick={() => window.open("https://www.instagram.com/volt.bjj")}
        >
          <InstagramIcon fontSize="small" />
        </IconButton>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Typography variant="body2">Affilié à</Typography>
          <Box
            component="img"
            src={homaLogo}
            alt="Homa BJJ"
            width={110}
            sx={{ cursor: "pointer" }}
            onClick={() => window.open("https://homabjj.com", "_blank")}
          />
        </Stack>
      </Stack>
    </Box>
  );
}
